/*document.addEventListener('DOMContentLoaded', function () {  
    const playButtons = document.querySelectorAll('.play-button');
    const modal = document.querySelector('.VideoModalFull');
    const closeModal = document.querySelector('.full-video-close');
    const videoElement = document.querySelector('.product-video-mp4-sound');
    const videoType = videoElement.tagName;
    let originalSrc;
    if(videoType == 'IFRAME'){
      originalSrc = videoElement.getAttribute('data-src');      
    }else{
      originalSrc = videoElement.querySelector('source').getAttribute('src')// Original video source URL
    }

  console.log('modal',modal)

    // Open Modal and Play Video
    playButtons.forEach(button => {
        button.addEventListener('click', function (e) {
          
            e.preventDefault();
            modal.style.display = 'block';
            modal.classList.add('modal--is-active');
            if(videoType == 'IFRAME'){
              videoElement.setAttribute('src', originalSrc); // Adding ?autoplay=1 for safety
            }else{
              // Set video source dynamically to force reload
              videoElement.pause();
              videoElement.querySelector('source').setAttribute('src', originalSrc + '?autoplay=1'); // Adding ?autoplay=1 for safety
              videoElement.load(); // Reload video to apply source change
              videoElement.play().catch(error => console.error('Autoplay failed:', error)); // Attempt to play video
            }
        });
    });

    // Close Modal and Stop Video
    closeModal.addEventListener('click', function () {
        modal.style.display = 'none';
        modal.classList.remove('modal--is-active');
        if(videoType == 'IFRAME'){
          videoElement.setAttribute('src','');
        }else{
          videoElement.pause();
          videoElement.currentTime = 0; // Reset video to the beginning
        }
    });

    // Close Modal when clicking outside the video content
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            modal.style.display = 'none';
            modal.classList.remove('modal--is-active');
            videoElement.pause();
            videoElement.currentTime = 0;
        }
    });

    // Prevent modal from closing when clicking inside the video container
    const modalInner = document.querySelector('.modal__inner');
    modalInner.addEventListener('click', function (e) {
        e.stopPropagation();
    });
});*/


$(document).ready(function(e){
  $(document).on('click','.play-button',function(e){
    e.preventDefault();
    let modal_id = $(this).data('id');
    let modal = document.getElementById(modal_id);
    if(!modal){
      return false;
    }
    let videoElement = modal.querySelector('.product-video-mp4-sound');
    let videoType = videoElement.tagName;
    let originalSrc;
    modal.style.display = 'block';
    modal.classList.add('modal--is-active');
    if(videoType == 'IFRAME'){
      originalSrc = videoElement.getAttribute('data-src');      
    }else{
      originalSrc = videoElement.querySelector('source').getAttribute('src')// Original video source URL
    }
    if(videoType == 'IFRAME'){
      videoElement.setAttribute('src', originalSrc); // Adding ?autoplay=1 for safety
    }else{
      // Set video source dynamically to force reload
      videoElement.pause();
      videoElement.querySelector('source').setAttribute('src', originalSrc + '?autoplay=1'); // Adding ?autoplay=1 for safety
      videoElement.load(); // Reload video to apply source change
      videoElement.play().catch(error => console.error('Autoplay failed:', error)); // Attempt to play video
    }
  });

  $(document).on('click','.full-video-close',function(e){
    let modal_id = $(this).parents('.VideoModalFull').attr('id');
    
    let modal = document.getElementById(modal_id);
    if(!modal){
      return false;
    }
    let videoElement = modal.querySelector('.product-video-mp4-sound');
    let videoType = videoElement.tagName;
    let originalSrc;
    
    modal.style.display = 'none';
    modal.classList.remove('modal--is-active');
    if(videoType == 'IFRAME'){
      videoElement.setAttribute('src','');
    }else{
      videoElement.pause();
      videoElement.currentTime = 0; // Reset video to the beginning
    }
  });
  // Prevent modal from closing when clicking inside the video container
  $(document).mouseup(function(e){
    var container = $(".modal__inner");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        // $('.full-video-close').click();
    }
  });  
})
